/**
 * Job adjustment API
 */

import api from "../../../shared/api.jsx";

const endpoints = {
  list: (jobId) => `/orders/${jobId}/adjustments`,
  pending: (jobId) => `/orders/${jobId}/adjustments/pending`,
  byId: (jobId, adjustmentId) => `/orders/${jobId}/adjustments/${adjustmentId}`,
  status: (jobId, adjustmentId) => `/orders/${jobId}/adjustments/${adjustmentId}/status`,
  previewProviderEmail: (jobId, adjustmentId) =>
    `/orders/${jobId}/adjustments/${adjustmentId}/preview-provider-email`,
};

export const fetchAdjustmentsByJobId = async (jobId) => {
  const response = await api.get(endpoints.list(jobId));
  return { success: response.success !== false, data: response.data || [], error: response.error };
};

export const fetchPendingAdjustments = async (jobId) => {
  const response = await api.get(endpoints.pending(jobId));
  return { success: response.success !== false, data: response.data || [], error: response.error };
};

export const createAdjustment = async (jobId, body) => {
  const response = await api.post(endpoints.list(jobId), body);
  return response;
};

export const updateAdjustmentStatus = async (jobId, adjustmentId, body) => {
  const response = await api.patch(endpoints.status(jobId, adjustmentId), body);
  return response;
};

export const fetchAdjustmentProviderEmailPreview = async (jobId, adjustmentId) => {
  const response = await api.get(endpoints.previewProviderEmail(jobId, adjustmentId));
  return response;
};
